var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ResourceTaskRunner = /** @class */ (function () {
    function ResourceTaskRunner(config, dispatch) {
        var _this = this;
        this.handleError = function (error) {
            _this.dispatch({
                type: 'error',
                error: error,
            });
        };
        this.config = config;
        this.dispatch = dispatch;
        this.stoppers = {};
    }
    ResourceTaskRunner.prototype.start = function (task) {
        switch (task.type) {
            case 'invalidate':
                return this.invalidate(task);
            case 'load':
            case 'manualLoad':
                return this.load(task);
            case 'purge':
                return this.purge(task);
            case 'subscribe':
                return this.subscribe(task);
        }
    };
    ResourceTaskRunner.prototype.stop = function (taskId) {
        var stopper = this.stoppers[taskId];
        if (stopper) {
            delete this.stoppers[taskId];
            try {
                stopper();
            }
            catch (error) {
                this.handleError(error);
            }
        }
    };
    ResourceTaskRunner.prototype.invalidate = function (task) {
        var _this = this;
        if (this.config.invalidate) {
            var running_1 = false;
            var invalidate = function (pointers) {
                if (pointers === void 0) { pointers = task.pointers; }
                if (running_1) {
                    throw new Error('Resource Error: an invalidator called its invalidate function ' +
                        "synchronously. Invalidation must happen asynchronously - you'll " +
                        'probably want some minimum time between invalidations.');
                }
                _this.dispatch(__assign(__assign({}, task), { pointers: pointers, type: 'invalidate', taskId: task.taskId }));
            };
            try {
                running_1 = true;
                var stopper = this.config.invalidate(__assign(__assign({}, task), { invalidate: invalidate }));
                running_1 = false;
                if (stopper) {
                    this.stoppers[task.taskId] = stopper;
                }
                else {
                    console.warn('Resource Warning: an invalidator task did not return ' +
                        "a cleanup function. If you don't want to invalidate your " +
                        "resources, set your resource's `purger` to `null` instead.");
                }
            }
            catch (error) {
                this.handleError(error);
            }
        }
    };
    ResourceTaskRunner.prototype.load = function (task) {
        if (task.request.load) {
            try {
                var stopper_1 = task.request.load(__assign(__assign({}, task), { abandon: this.handleAbandon.bind(this, task), error: this.handleError, update: this.handleUpdate.bind(this, task) }));
                this.stoppers[task.taskId] = function () {
                    if (stopper_1) {
                        stopper_1();
                    }
                };
            }
            catch (error) {
                this.handleError(error);
            }
        }
    };
    ResourceTaskRunner.prototype.purge = function (task) {
        var _this = this;
        if (this.config.purge) {
            var purge = function (pointers) {
                if (pointers === void 0) { pointers = task.pointers; }
                // Always purge asynchronously
                setTimeout(function () {
                    _this.dispatch(__assign(__assign({}, task), { pointers: pointers, type: 'purge', taskId: task.taskId }));
                });
            };
            try {
                var stopper = this.config.purge(__assign(__assign({}, task), { purge: purge }));
                if (stopper) {
                    this.stoppers[task.taskId] = stopper;
                }
                else {
                    console.warn('Resource Warning: a purge task did not return a cleanup function. ' +
                        "If you don't want to purge your data, set your resource's " +
                        'purger task to "null" instead. But beware - this can lead to ' +
                        'memory leaks.');
                }
            }
            catch (error) {
                this.handleError(error);
            }
        }
    };
    ResourceTaskRunner.prototype.subscribe = function (task) {
        if (task.request.subscribe) {
            try {
                var stopper = task.request.subscribe(__assign(__assign({}, task), { abandon: this.handleAbandon.bind(this, task), error: this.handleError, update: this.handleUpdate.bind(this, task) }));
                if (!stopper) {
                    throw new Error('Resource Error: subscribe tasks must return a cleanup function.');
                }
                this.stoppers[task.taskId] = stopper;
            }
            catch (error) {
                this.handleError(error);
            }
        }
    };
    ResourceTaskRunner.prototype.handleAbandon = function (task) {
        this.dispatch(__assign(__assign({}, task), { type: 'abandonTask', taskId: task.taskId }));
    };
    ResourceTaskRunner.prototype.handleUpdate = function (task, chunks) {
        if (this.stoppers[task.taskId]) {
            this.dispatch(__assign(__assign({}, task), { type: 'updateValue', taskId: task.taskId, chunks: chunks, timestamp: Date.now() }));
        }
    };
    return ResourceTaskRunner;
}());
export { ResourceTaskRunner };
//# sourceMappingURL=taskRunner.js.map